import { Button } from '@/components/Button';
import { ChevronLeft } from '@/components/Icons';
import { ReactElement } from 'react';
import { TablePaginationProps } from '../../types';

const START_PAGE = 0;

export const TablePagination = ({
  pageIndex,
  nextDisabled,
  prevDisabled,
  totalPages,
  onPrevPage,
  onPageChange,
  onNextPage,
}: TablePaginationProps): ReactElement => {
  const pages = Array.from(
    { length: totalPages - START_PAGE },
    (_, i) => i + START_PAGE,
  );

  return (
    <div className="flex w-full justify-center gap-1.25">
      <Button variant="gray" isDisabled={prevDisabled} onClick={onPrevPage}>
        <ChevronLeft />
      </Button>
      {pages.map((page) => {
        return (
          <Button
            className={
              pageIndex === page + 1 ? 'bg-primaryBlue text-white' : ''
            }
            key={page}
            variant="gray"
            onClick={() => onPageChange(page)}
          >
            {page + 1}
          </Button>
        );
      })}
      <Button variant="gray" isDisabled={nextDisabled} onClick={onNextPage}>
        <ChevronLeft className="rotate-180 transform" />
      </Button>
    </div>
  );
};
